import React from "react";

import i18n from "../../constants/i18n";

import Breadcrumb from "../Breadcrumb";
import ShowIf from "../ShowIf";
import Warning from "../Warning";

import styles from "./DeviceOverview.module.scss";
import Table from "./Table";

const Loader = () => (
    <div className={`is-relative ${styles.loaderContainer}`}>
        <div className="loader" />
    </div>
);

const Links = ({ onRoomLinkClick, onAddDeviceLinkClick }) => (
    <div className="level-right">
        <div className="level-item">
            <button
                onClick={onRoomLinkClick}
                className="button is-secondary is-rounded"
            >
                {i18n.generic.roomManagement}
            </button>
            <button
                onClick={onAddDeviceLinkClick}
                className="button is-primary is-rounded"
            >
                {i18n.deviceOverview.addDevice}
            </button>
        </div>
    </div>
);

const DeviceOverviewView = ({
    crematory,
    devices,
    onAddDeviceLinkClick,
    onBackLinkClick,
    onDeviceDeleteRequest,
    onDeviceEditRequest,
    onRoomLinkClick,
    rooms
}) => {
    return (
        <div className="container">
            <Breadcrumb
                label="Terug naar plechtigheden"
                onClick={onBackLinkClick}
            />
            <div className={`level ${styles.linkContainer}`}>
                <div className="level-left">
                    <h1>{i18n.generic.deviceManagement}</h1>
                </div>
                <ShowIf condition={crematory && crematory.item}>
                    <Links
                        onRoomLinkClick={onRoomLinkClick}
                        onAddDeviceLinkClick={onAddDeviceLinkClick}
                    />
                </ShowIf>
            </div>
            {!crematory || crematory.isFetching ? (
                <Loader />
            ) : (
                <React.Fragment>
                    <Table
                        devices={devices}
                        rooms={rooms}
                        onDelete={onDeviceDeleteRequest}
                        onEdit={onDeviceEditRequest}
                    ></Table>
                    <ShowIf condition={!crematory.error && !devices.length}>
                        <Warning>{i18n.generic.noResultsFound}</Warning>
                    </ShowIf>
                </React.Fragment>
            )}
            <ShowIf
                condition={
                    crematory && !crematory.isFetching && crematory.error
                }
            >
                <Warning>{i18n.generic.error}</Warning>
            </ShowIf>
        </div>
    );
};

export default DeviceOverviewView;
